<div class="continer-popup-help" >
    <div class="popup">
        <!-- <div class="header-tooltip">
             <button class="btn-close" (click)="closePopup.emit()"></button>
        </div> -->
        <div class="wrapper">    
            <img src="./assets/icons/logout.png" alt="logout">
            <div class="bodyMessage">
          <h1> עוד רגע אנחנו נפרדים)-:</h1>
            <p class="p2">תהליך ההזדהות עומד להתנתק בדקות הקרובות </p>
             </div>
             <p-button  class="buttonClose" (click)="closePopup.emit()" label="להמשיך"> </p-button>
             <p-button  class="buttonlogout" (click)="logout.emit()" label="להתחיל מחדש"> </p-button>
        </div>
     

    </div>

